import React from 'react';
import LineChart from '../charts/LineChart05';

// Import utilities
import { tailwindConfig, hexToRGB } from "../../../../utils/Utils";

function FintechCard01() {

  const chartData = {
    labels: [
      // '12-01-2020', '01-01-2021', '02-01-2021',
      // '03-01-2021', '04-01-2021', '05-01-2021',
      // '06-01-2021', '07-01-2021', '08-01-2021',
      // '09-01-2021', '10-01-2021', '11-01-2021',
      // '12-01-2021', '01-01-2022', '02-01-2022',
      // '03-01-2022', '04-01-2022', '05-01-2022',
      // '06-01-2022', '07-01-2022', '08-01-2022',
      // '09-01-2022', '10-01-2022', '11-01-2022',
      // '12-01-2022', '01-01-2023', '02-01-2023',
      // '03-01-2023', '04-01-2023', '05-01-2023',
      '01-01-2023', '01-02-2023', '01-03-2023',
      '01-04-2023', '01-05-2023', '01-06-2023',
      '01-07-2023', '01-08-2023', '01-09-2023',
      '01-10-2023', '01-11-2023', '01-12-2023',
      '01-13-2023', '01-14-2023', '01-15-2023',
      '01-16-2023', '01-17-2023', '01-18-2023'
    ],
    datasets: [
      // Indigo line
      {
        label: 'Attendees',
        data: [
          0, 2.5, 2.5, 4, 2.5, 3.8, 5, 9, 7.5, 11,
          14, 15, 17, 15, 14, 9, 15, 26, 16, 18,
          15, 20, 18, 19, 19, 24, 29, 26, 39, 27,
          35, 32, 29, 35, 36, 34, 39, 36, 41, 41,
          48,
        ],
        borderColor: tailwindConfig().theme.colors.indigo[500],
        fill: true,
        backgroundColor: `rgba(${hexToRGB(tailwindConfig().theme.colors.blue[500])}, 0.08)`,
        borderWidth: 2,
        tension: 0,
        pointRadius: 0,
        pointHoverRadius: 3,
        pointBackgroundColor: tailwindConfig().theme.colors.indigo[500],
        clip: 20,
      },
      // Yellow line
      {
        label: 'Check-ins',
        data: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
          10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,29, 26, 39, 27,
          35, 32, 29, 35, 36, 34, 39, 36, 41, 41,
          48,
        ],
        borderColor: tailwindConfig().theme.colors.yellow[400],
        // borderDash: [4, 4],
        fill: false,
        borderWidth: 2,
        tension: 0,
        pointRadius: 0,
        pointHoverRadius: 3,
        pointBackgroundColor: tailwindConfig().theme.colors.yellow[600],
        clip: 20,
      },
      // gray line
      {
        label: 'Check-outs',
        data: [
          0.7, 3.5, 4.5, 3.5, 4.2, 4.6, 6, 7, 6, 6,
          11, 13, 14, 18, 17, 15, 13, 16, 20, 21,
          24, 22, 20, 22, 25, 18, 21, 23, 24, 32,
          28, 29, 35, 37, 42, 32, 32, 33, 33, 37,
          32,
        ],
        borderColor: tailwindConfig().theme.colors.orange[400],
        fill: false,
        borderWidth: 2,
        tension: 0,
        pointRadius: 0,
        pointHoverRadius: 3,
        pointBackgroundColor: tailwindConfig().theme.colors.orange[400],
        clip: 20,
      },
    ],
  };

  return (
    <div className="flex flex-col col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-[#eff4ff]">
      <header className="px-5 py-4 border-b border-slate-100 flex items-center">
        <h2 className="font-semibold text-slate-800">Event Attendees</h2>
      </header>
      {/* Chart built with Chart.js 3 */}
      {/* Change the height attribute to adjust the chart height */}
      <LineChart data={chartData} width={800} height={300} toolTip="Attendees"/>
    </div>
  );
}

export default FintechCard01;
